import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue"
import ExamIndex from "@/layout/examIndex.vue"
import noNavLayout from "@/layout/noNavIndex.vue"
import store from '@/store'


Vue.use(VueRouter);
const routes: Array<RouteConfig> = [
   {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/",
    name: '/home',
    component: Layout,
    children: [
      { path: 'home', name: 'home', component: () => import('@/views/home/index.vue') }, // 
    ],
  },
  {
    path: "/registration",
    name: 'registration',
    component: Layout,
    children: [
      { path: '/', 
        name: 'registration',
        component: ExamIndex,
        children: [
          { path: '/registration', name: 'registration', component: () => import('@/views/registration/index.vue'), meta: { title: '报考类型', titleEn: 'Test Type', type: 'registration' }},
          { path: 'Information', name: 'Information', component: () => import('@/views/registration/Information.vue'), meta: { title: '报考类型/报名须知', titleEn: 'Test Type / Registration Guidelines', type: 'registration' } },
        ]
      },
      // { path: 'nopayOrder', name: 'nopayOrder', component: () => import('@/views/registration/nopayOrder.vue'), meta: { title: '考试订单/支付订单', type: 'nopayOrder' } },
    ],
  },
  {
    path: "/nopayOrder",
    name: 'nopayOrder',
    component: Layout,
    children: [
      { path: '/', 
        name: 'nopayOrder',
        component: ExamIndex,
        children: [
          { path: '/nopayOrder', name: 'nopayOrder', component: () => import('@/views/registration/nopayOrder.vue'), meta: { title: '考试订单/支付订单', titleEn: 'Test Orders / Payment Order',  type: 'nopayOrder' } },
        ]
      },
    ],
  },
  {
    path: "/order",
    name: 'order',
    component: Layout,
    children: [
       { path: '/', 
        name: 'order',
        component: ExamIndex,
        children: [
          { path: '/order', name: 'order', component: () => import('@/views/order/index.vue'), meta: { title: '订单', titleEn: 'Orders', type: 'order' }},
        ]
      },
    ],
  },
  {
    path: "/appealReconsiderationList",
    name: 'appealReconsiderationList',
    component: Layout,
    children: [
       { path: '/', 
        name: 'appealReconsiderationList',
        component: ExamIndex,
        children: [
          { path: '/appealReconsiderationList', name: 'appealReconsiderationList', component: () => import('@/views/appealReconsiderationList/index.vue'), meta: { title: '申诉/复议', titleEn: 'Appeal / Review', type: 'appealReconsiderationList' }},
        ]
      },
    ],
  },
  {
    path: "/appealReconsideration",
    name: 'appealReconsideration',
    component: Layout,
    children: [
       { path: '/', 
        name: 'appealReconsideration',
        component: ExamIndex,
        children: [
          { path: '/appealReconsideration', name: 'appealReconsideration', component: () => import('@/views/appealReconsideration/index.vue'), meta: { title: '申诉/复议', titleEn: 'Appeal / Review', type: 'appealReconsideration' }},
        ]
      },
    ],
  },
   {
    path: "/appealReconsiderationPay",
    name: 'appealReconsiderationPay',
    component: Layout,
    children: [
      { path: '/', 
        name: 'appealReconsiderationPay',
        component: ExamIndex,
        children: [
          { path: '/appealReconsiderationPay', name: 'appealReconsiderationPay', component: () => import('@/views/appealReconsiderationPay/nopayOrder.vue'), meta: { title: '成绩复议/申诉', titleEn:'Results Appeal / Review', type: 'appealReconsiderationPay' } },
        ]
      },
    ],
  },
  {
    path: '/signPayReturn',
    name: 'signPayReturn',
    component: () => import ('@/components/signPayReturn.vue'), // 签署支付
    meta: {
      title: '支付详情',
      type: 'signPayReturn' 
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  base: process.env.BASE_URL,
});
router.beforeEach(async (to: any, from: any, next: any) => {
  next();
});
router.afterEach((to) => {
  window.scrollTo(0, 0);
});
export default router;
